import { api_subscribe_user_path } from '../../routes';
import { ANNUAL_REFERRAL_OFFER_CODE, DISCOUNTED_REFERRAL_PRICE } from '../../src/constants';
import request from './request';

export const REFERRAL_ANNUAL = {
  cycle: 'year',
  plan: ANNUAL_REFERRAL_OFFER_CODE,
  total: {
    label: `Annual Subscription with 14 Days Trial ($${DISCOUNTED_REFERRAL_PRICE}.00 after free trial)`,
    amount: 0,
  },
  price: DISCOUNTED_REFERRAL_PRICE,
};

export interface CurrentPlanSelection {
  cycle: string;
  plan: string;
  total?: {
    label: string;
    amount: number;
  };
  price: number;
}

export interface SubscribeUserParams {
  modal?: string;
  plan: string;
  referrer_guid?: string;
  setup_intent_id: string;
}

export interface SubscribeUserResponse {
  affiliation: string;
  email: string;
  initialSubscriptionPrice: string;
  offerCode: string;
  productSku: string;
  redirectTo: string;
  stripePlanName: string;
  subscriptionVariant: string;
  trackConversion: boolean;
  userId: number;
}

export async function subscribeUser(params: SubscribeUserParams): Promise<SubscribeUserResponse> {
  const response = await request('post', api_subscribe_user_path(params));
  return response;
}
